<acabim-card cardHeading="Create Export Request" [isCollapsible]="false" [cardContent]="cardContent"
             *ngIf="(projectApiService.selectedProjectId$ | async)"></acabim-card>

<ng-template #cardContent>

    <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" [shortFields]="true" class="col-md-6">
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Model</acabim-form-input-label>
            <acabim-form-input-content>
                <p-dropdown [(ngModel)]="selectedModel"
                            id="bim-model"
                            inputId="bim-model"
                            [options]="models" optionLabel="name">
                </p-dropdown>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <div class="cas-action-buttons">
            <button (click)='startExport()' class="cas-button-action">Export Model</button>
        </div>
    </acabim-form-block>

</ng-template>
